import type { EvaluationDomain, OperandDto } from "../../../../../types/resolver";
import { CASE_CONTEXT_KEYS, CODES_CONTEXT_KEYS, SPAN_CONTEXT_KEYS } from "../WhenBuilder/OperandBuilder/constants";

/** First context key for the evaluation domain (matches KeyOperand options). */
export function defaultKeyOperandForEvaluationDomain(domain: EvaluationDomain | undefined): OperandDto {
    if (domain === "CASE") {
        return { operandType: "key", key: CASE_CONTEXT_KEYS[0] };
    }
    if (domain === "SPANS" || domain === "LOOSE_SPANS") {
        return { operandType: "key", key: SPAN_CONTEXT_KEYS[0] };
    }
    return { operandType: "key", key: CODES_CONTEXT_KEYS[0] };
}
